/** Mirrors API `InfoShareRepository.MaxRelativeExpiryDays`. */
export const MAX_RELATIVE_EXPIRY_DAYS = 90;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Cap an absolute expiry so it is at most `now + MAX_RELATIVE_EXPIRY_DAYS`. */
export function clampExpiresAtToMaxRelative(expiresAt: Date, now: Date = new Date()): Date {
  const max = new Date(now.getTime() + MAX_RELATIVE_EXPIRY_DAYS * MS_PER_DAY);
  return expiresAt.getTime() > max.getTime() ? max : expiresAt;
}

/**
 * Max days that can be added to `currentExpiry` without exceeding
 * `now + MAX_RELATIVE_EXPIRY_DAYS` (API extend rule).
 */
export function maxExtendDaysFromNow(currentExpiry: Date, now: Date = new Date()): number {
  const maxExpiry = new Date(now.getTime() + MAX_RELATIVE_EXPIRY_DAYS * MS_PER_DAY);
  const remainingMs = maxExpiry.getTime() - currentExpiry.getTime();
  if (remainingMs <= 0) {
    return 0;
  }
  return Math.floor(remainingMs / MS_PER_DAY);
}
